import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface ProductRequest {
  id?:number,
  name: string,
  description?: string,
  images?: string,
  price?: number,
  sale_price?: number,
  quantity: number,
  detail?: string, 
  status: string,
  cat_id: number | null
}
export interface ProductResponse {
  id?:number,
  name: string,
  description?: string,
  images?: string,
  price: number,
  sale_price?: number,
  quantity: number,
  detail?: string, 
  status: string,
  cat_id: number | null
}

export interface ProductCategoryRequest {
  id?:number,
  name: string,
  order?: number,
  parent_id?: number
}
export interface ProductCategoryResponse {
  id?:number,
  name: string,
  order?: number,
  parent_id?: number
}
export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/product',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['products','categories'],

  endpoints: (builder) => ({
    getShopProducts: builder.query({
      query: () => 'all',
      providesTags: ['products']
    }),
    getProduct: builder.query({
      query: (id) => `/${id}`,
      providesTags: ['products']
    }),
    createProduct: builder.mutation<ProductResponse, ProductRequest>({
      query: (data) => ({
        url: '/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['products']
    }),
    updateProduct: builder.mutation<ProductResponse, Partial<ProductRequest> & Pick<ProductRequest, 'id'>>({
      query: ({ id, ...patch }) => ({
        url: `/${id}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: ['products']
    }),
    deleteProduct: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['products']
    }),
    //category
    getProductCategory: builder.query({
      query: (id) => `/categories/${id}`,
      providesTags: ['categories']
    }),
    getProductCats: builder.query({
      query: () => '/categories/all',
      providesTags: ['categories']
    }),
    createProdCategory: builder.mutation<ProductCategoryResponse, ProductCategoryRequest>({
      query: (data) => ({
        url: '/categories/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['categories']
    }),
    updateProdCategory: builder.mutation<ProductCategoryResponse, Partial<ProductCategoryRequest> & Pick<ProductCategoryRequest, 'id'>>({
      query: ({ id, ...patch }) => ({
        url: `/categories/${id}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: ['categories']
    }),
    deleteProdCategory: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `/categories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['categories']
    }),
  }),
})

export const { 
  useGetShopProductsQuery , useGetProductQuery, useGetProductCatsQuery , 
  useDeleteProductMutation , useCreateProductMutation , useUpdateProductMutation ,
  useCreateProdCategoryMutation , useUpdateProdCategoryMutation , useDeleteProdCategoryMutation ,
  useLazyGetProductCategoryQuery
} = productApi